<h1 mat-dialog-title [attr.data-cy]="'dsmdsmd_h1_1'">{{ input?.title }}</h1>
<div mat-dialog-content>
    <div class="one-row">
        <span class="spacer"></span>
        <ng-container *ngFor="let m of input?.mandanten; let i = index">
            <div (click)="setMandant(m)" class="mandant-button" [attr.data-cy]="'dsmdsmd_button_' + i">
                <mat-icon color="accent" style="transform: scale(2.4)" [attr.data-cy]="'dsmdsmd_mat-icon_1'"
                    >house</mat-icon
                >
                <p style="margin-top: 36px">{{ m.bezeichnung }} ({{ i + 1 }})</p>
            </div>
            <span class="spacer"></span>
        </ng-container>
    </div>
</div>
